import React from 'react';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { useParams } from 'react-router-dom';
import Grid from '../../grid/Grid';
import Column from '../../grid/Column';
import { Page } from 'components/Elements/Page';
import { Field } from 'components/Form/Field';
import { Form } from 'components/Form/Form';
import { resetPassword } from 'app/actions/userActions';
import { useAuth0 } from '@auth0/auth0-react';
import LoadingButton from '@mui/lab/LoadingButton';
import { ResetPasswordParams } from 'app/routes/SchoolRoutes';

export const ResetPassword = () => {
	const { isAuthenticated } = useAuth0();
	const dispatch = useAppDispatch();
	const status = useAppSelector((state) => state.user.status);
	const errorMessage = useAppSelector((state) => state.errors.errorMessage);
	const { token, slug: schoolSlug } = useParams() as ResetPasswordParams;

	const handleSubmit = (section, form, values, nopersist) => {
		dispatch(
			resetPassword(
				{
					password: nopersist.auth_resetpassword_password,
					confirm_password: nopersist.auth_resetpassword_confirm_password,
				},
				token,
				schoolSlug,
			),
		);
	};

	const getFields = () => {
		const props = {
			section: 'auth',
			stage: 'resetpassword',
			required: true,
		};

		return [
			<Field
				{...props}
				key="password"
				type="password"
				name="password"
				label="Enter your password"
			/>,
			<Field
				{...props}
				key="password_confirmation"
				type="password"
				name="password_confirmation"
				label="Confirm your password"
			/>,
		];
	};

	const isLoading = status === 'loading';

	if (isAuthenticated) {
		return <></>;
	}

	return (
		<Page>
			<Grid>
				<Column columns={10} center className="grid__md--4 grid__lg--3">
					<h2>Reset password</h2>
					{/* @ts-expect-error TS(2746): This JSX tag's 'children' prop expects a single ch... Remove this comment to see the full error message */}
					<Form
						section="auth"
						stage="resetpassword"
						ownFields={getFields()}
						onSubmit={handleSubmit}
					>
						{errorMessage ? <p>{errorMessage}</p> : <></>}
						<LoadingButton
							variant={errorMessage ? 'outlined' : 'contained'}
							type="submit"
							loading={isLoading}
							disabled={isLoading}
							sx={{ width: '100%' }}
						>
							Submit
						</LoadingButton>
					</Form>
				</Column>
			</Grid>
		</Page>
	);
};

// for React.lazy
export default ResetPassword;
